import * as React from "react";

export interface TextareaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className = "", ...props }, ref) => {
        return (
            <textarea
                ref={ref}                                    // <-- cần cho RHF.reset
                className={
                    "w-full min-h-[96px] rounded-md border px-3 py-2 text-sm " +
                    "focus:outline-none focus:ring-2 focus:ring-offset-2 " +
                    "border-neutral-300 focus:ring-neutral-800 " +
                    className
                }
                {...props}
            />
        );
    }
);
Textarea.displayName = "Textarea";

export default Textarea;
